import Grid from '@mui/material/Grid2';
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function LocationType({ state, updateState }: IProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var index = Number.parseInt((event.target as HTMLInputElement).value)

        updateState({
            locationType: index,
        })
    }

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Typography>Location Type</Typography>

            <Grid size={12}>
                <RadioGroup onChange={handleChange} value={state.locationType}>
                    <FormControlLabel
                        key={3}
                        value={3}
                        control={<Radio />}
                        label={
                            <>
                                All
                            </>
                        }
                    />
                    <FormControlLabel
                        key={0}
                        value={0}
                        control={<Radio />}
                        label={
                            <>
                                Outer
                                <Tooltip title={"Outer location types are Suburban Area, Edge of Town and Neighbourhood Centre (excluding Village sub location type)"}>
                                    <InfoOutlinedIcon sx={{ paddingLeft: "5px", height: "initial", fontSize: "1.1rem" }} />
                                </Tooltip>
                            </>
                        }
                    />
                    <FormControlLabel
                        key={1}
                        value={1}
                        control={<Radio />}
                        label={
                            <>
                                Inner
                                <Tooltip title={"Inner location types are Town Centre and Edge of Town Centre"}>
                                    <InfoOutlinedIcon sx={{ paddingLeft: "5px", height: "initial", fontSize: "1.1rem" }} />
                                </Tooltip>
                            </>
                        }
                    />
                    <FormControlLabel
                        key={2}
                        value={2}
                        control={<Radio />}
                        label={
                            <>
                                Rural
                                <Tooltip title={"Rural location types are Neighbourhood Centre (only Village sub location type) and Free Standing"}>
                                    <InfoOutlinedIcon sx={{ paddingLeft: "5px", height: "initial", fontSize: "1.1rem" }} />
                                </Tooltip>
                            </>
                        }
                    />
                </RadioGroup>
            </Grid>
        </Grid>
    )
}
